import { render } from "./GuestDashboard.vue?vue&type=template&id=68a0f9c7&scoped=true"
const script = {}

import "./GuestDashboard.vue?vue&type=style&index=0&id=68a0f9c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a0f9c7"]])

export default __exports__